// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__1N0qT"};